import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createProductReturn = createAction(ACTION.CREATE_PRODUCT_RETURN.REQUEST, params => ({params}));